import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(horoscope)/horoscope/compatibility/shared/CompatibilityPickerClient.tsx");
